import { DefaultValue, selectorFamily } from 'recoil';
export const radioGroupFromBooleanSelectorFamily = selectorFamily({
    key: 'utils/radioGroupFromBoolean',
    get: (selector) => ({ get }) => {
        const booleanValue = get(selector);
        if (booleanValue === undefined) {
            return null;
        }
        return booleanValue ? 1 : 0;
    },
    set: (selector) => ({ set }, value) => {
        set(selector, value instanceof DefaultValue ? undefined : !!value);
    },
});
